import { Component, OnInit } from '@angular/core';
import { MaintenanceService } from '../shared/maintenance/maintenance.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'wsg-bce-home',
  templateUrl: './bce-home.component.html',
  styleUrls: ['./bce-home.component.css']
})
export class BceHomeComponent implements OnInit {

  maintenanceMessage = '';
  processingMaintenance = false;

  constructor(private maintenanceService: MaintenanceService, private snackbar: MatSnackBar) {

  }

  ngOnInit() {
    this.processingMaintenance = true;
    this.maintenanceService.get()
                           .subscribe(maintenanceMessage => {
                            this.maintenanceMessage = maintenanceMessage.message;
                            this.processingMaintenance = false;
                           }, error => {
                            this.snackbar.open('Error retrieving maintenance', 'DISMISS', { duration: 2000 });
                            this.processingMaintenance = false;
                           });
  }
}
